import * as React from 'react';

import { cn } from '@/lib/utils';

const Textarea = React.forwardRef(
  ({ className, ...props }: React.ComponentProps<'textarea'>, ref: React.Ref<HTMLTextAreaElement>) => {
    return (
      <textarea
        data-slot="textarea"
        className={cn(
          'para:border-border para:placeholder:text-muted-foreground para:selection:bg-primary para:selection:text-primary-foreground para:flex para:min-h-24 para:w-full para:min-w-0 para:rounded-md para:border para:bg-muted para:px-3 para:py-2 para:text-base para:transition-[color,box-shadow] para:outline-none para:disabled:pointer-events-none para:disabled:cursor-not-allowed para:disabled:opacity-50 para:md:text-sm',
          'para:focus-visible:border-ring para:focus-visible:ring-ring/50',
          'para:aria-invalid:ring-destructive/20 para:dark:aria-invalid:ring-destructive/40 para:aria-invalid:border-destructive',
          className,
        )}
        {...props}
        ref={ref}
      />
    );
  },
);

export { Textarea };
